import { render, staticRenderFns } from "./Histogram.vue?vue&type=template&id=692690ec&scoped=true&"
import script from "./Histogram.vue?vue&type=script&lang=js&"
export * from "./Histogram.vue?vue&type=script&lang=js&"
import style0 from "./Histogram.vue?vue&type=style&index=0&id=692690ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692690ec",
  null
  
)

export default component.exports